import React, { useState, useEffect, ChangeEvent } from 'react';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import { TextField, Button, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useAuth, useAlert, useCancelShooting, useProfile } from 'hooks';
import { hideModal } from 'state/actions';
import { LOADING } from 'state/constants';
import { ALERT, MODAL } from 'config/constants';
import { HvModal, HvButton, HvPleaseWait } from 'components';
import { initializeCentrisTransferRequest } from 'apis';

const useStyles = makeStyles({
  description: {
    fontSize: 14,
    marginBottom: 16,
  },
  inputBox: {
    width: '100%',
    height: 100,

    '& .MuiInputBase-root': {
      height: '100%',
      alignItems: 'flex-start',
    },
  },
  nevermind: {
    textTransform: 'none',
    textDecoration: 'underline',
    marginRight: 'auto',
  },
  invalidInput: {
    '& .MuiInputBase-root': {
      borderColor: 'red',
      borderWidth: '1px',
      borderStyle: 'solid',
    },
  },
});

function RequestModal() {
  const intl = useIntl();
  const styles = useStyles();
  const dispatch = useDispatch();

  const { token, user } = useAuth();
  const { profile } = useProfile(token, user.email);

  const onClose = () => {
    dispatch(hideModal(MODAL.TRANSER_REQUEST));
  };

  const onStart = async () => {
    initializeCentrisTransferRequest(token);
    dispatch(hideModal(MODAL.TRANSER_REQUEST));
  };

  const buttons = (
    <HvButton onClick={onStart}>{intl.formatMessage({ id: 'profile.reqestDlg.button' })}</HvButton>
  );

  return (
    <HvModal
      title={intl.formatMessage({ id: 'profile.reqestDlg.title' })}
      buttons={buttons}
      onClose={onClose}
    >
      <Typography className={styles.description}>
        {intl.formatMessage({ id: 'profile.reqestDlg.content1' })}
      </Typography>
      <Typography className={styles.description}>
        {intl.formatMessage({ id: 'profile.reqestDlg.content2' })}
      </Typography>
    </HvModal>
  );
}
export default RequestModal;
